// UI Text Configuration
export const uiText = {
  navbar: {
    facultyList: {
      vellore: "Faculty List (Fall 25-26)",
      chennai: "Faculty List (Fall 25-26)",
      ap: "Faculty List (Fall 23-24)"
    }
  }
};

export default uiText;